import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ConsultingPage from "./pages/ConsultingPage";
import ConsultingFocusAreaDetailPage from "./pages/ConsultingFocusAreaDetailPage";
import CoachingPage from "./pages/CoachingPage";
import CoachingOptionDetailPage from "./pages/CoachingOptionDetailPage";
import ProgramsPage from "./pages/ProgramsPage";
import ProgramDetailPage from "./pages/ProgramDetailPage";
import InsightsPage from "./pages/InsightsPage";
import BlogPostPage from "./pages/BlogPostPage";
import CorporateTrainingPage from "./pages/CorporateTrainingPage";
import CorporateTrainingDetailPage from "./pages/CorporateTrainingDetailPage";
import ContactPage from "./pages/ContactPage";

import AdminDashboard from "./pages/admin/Dashboard";
import AdminPages from "./pages/admin/Pages";
import AdminPrograms from "./pages/admin/Programs";
import AdminBlog from "./pages/admin/Blog";
import AdminLogin from "./pages/admin/Login";
import AdminMedia from "./pages/admin/Media";
import PageForm from "./components/admin/PageForm";
import ProgramForm from "./components/admin/ProgramForm";
import BlogForm from "./components/admin/BlogForm";
import AdminInsights from "./pages/admin/Insights";
import CorporateTrainingSettings from "./pages/admin/CorporateTrainingSettings";
import AdminSettings from "./pages/admin/Settings";
import ContactMessages from "./pages/admin/ContactMessages";

import PrivateRoute from "./components/PrivateRoute";
import AdminLayout from "./components/admin/AdminLayout";
import HomepageManagement from "./pages/admin/HomepageManagement";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        {/* Show regular navigation for non-admin routes */}
        {!window.location.pathname.startsWith("/admin") && <Navigation />}

        <main className="flex-grow">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/consulting" element={<ConsultingPage />} />
            <Route
              path="/consulting/focus-area/:id"
              element={<ConsultingFocusAreaDetailPage />}
            />
            <Route path="/coaching" element={<CoachingPage />} />
            <Route
              path="/coaching/option/:id"
              element={<CoachingOptionDetailPage />}
            />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/programs/:slug" element={<ProgramDetailPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:slug" element={<BlogPostPage />} />
            <Route
              path="/corporate-training"
              element={<CorporateTrainingPage />}
            />
            <Route
              path="/corporate-training/program/:id"
              element={<CorporateTrainingDetailPage />}
            />
            <Route path="/contact" element={<ContactPage />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/pages"
              element={
                <PrivateRoute>
                  <AdminPages />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/pages/:id/edit"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <PageForm />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/pages/new"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <PageForm />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/programs"
              element={
                <PrivateRoute>
                  <AdminPrograms />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/programs/:id/edit"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <ProgramForm />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/programs/new"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <ProgramForm />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/blog"
              element={
                <PrivateRoute>
                  <AdminBlog />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/blog/:id/edit"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <BlogForm />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/blog/new"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <BlogForm />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/insights"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <AdminInsights />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/corporate-training"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <CorporateTrainingSettings />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/media"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <AdminMedia />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/contact-messages"
              element={
                <PrivateRoute>
                  <ContactMessages />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/homepage"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <HomepageManagement />
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <PrivateRoute>
                  <AdminSettings />
                </PrivateRoute>
              }
            />
          </Routes>
        </main>

        {/* Show regular footer for non-admin routes */}
        {!window.location.pathname.startsWith("/admin") && <Footer />}
      </div>
    </Router>
  );
}

export default App;
